import { Icon as I } from "@flightpath/coreui"
import { IconSymbols } from "@flightpath/coreui/dist/generated/IconSymbols";
import { IconProps as IP } from "@flightpath/coreui/dist/ui/Icon"
const Icon = I.Icon;
export interface IconProps extends IP { }
export { Icon, IconSymbols };

